import React, { useState } from 'react';
import {Button, Tooltip, Modal, Input, Spin, Tag} from 'antd';
import { DownloadOutlined, SaveOutlined } from '@ant-design/icons';
import apiService from "../api";
import axios from "axios";
import {DEFAULT_URL} from "../constants";

const ButtonGroup: React.FC<{
    placement: string,
    checkedList: any,
    calculationFilter: any,
    filters: any,
    downloadCsv: React.MouseEventHandler<HTMLElement> | undefined
    setFilters: Function
}> = ({ placement, checkedList, calculationFilter, filters, downloadCsv , setFilters}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [reportName, setReportName] = useState('');
    const [loading, setLoading] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    };


    const handleOk = async () => {
        setLoading(true);
        try {
            //    const {report_name,report_tab,section,columns,aggregation,filters, calc_filters} = req.body;
            await axios({
                method: 'post',
                data: {
                    report_name: reportName,
                    report_tab: null,
                    section: null,
                    columns: JSON.stringify(checkedList),
                    aggregation: placement,
                    filters: JSON.stringify(filters),
                    calc_filters: JSON.stringify(calculationFilter),
                    checkedList:JSON.stringify(checkedList), calculationFilter: JSON.stringify(calculationFilter)},
                url: `${DEFAULT_URL}save_report`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            });
            await apiService.post('save_report', {placement, checkedList, calculationFilter, });
            setIsModalVisible(false);
            console.log(reportName);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
            setIsModalVisible(false);

        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const getFilters = () => {
        const appliedFilters = []
        for(const filterName in filters){
            for (const filter of filters?.[filterName]){
                if(filter.value !== null && filter.value !== undefined && filter.value !== ''){
                    appliedFilters.push({field: filter.field, operator: filter.operatorValue,value: filter.value})
                }
            }
        }
        return appliedFilters
    }

    const removeFilter = (fieldToRemove: string) => {
            const clonedFilters = JSON.parse(JSON.stringify(filters));

            for (const key in clonedFilters) {
                if (clonedFilters.hasOwnProperty(key)) {
                    //@ts-ignore
                    clonedFilters[key].forEach(field => {
                        if (field.field === fieldToRemove ) {
                            field.value = '';
                        }
                    });
                }
            }
            console.log(clonedFilters)
            setFilters(clonedFilters);
        // Update the filters state to remove the filter with the matching field
        // setFilters(prevFilters => {
        //     const updatedFilters = { ...prevFilters };
        //     for (const filterName in updatedFilters) {
        //         updatedFilters[filterName] = updatedFilters[filterName].filter(filter => filter.field !== fieldToRemove);
        //     }
        //     return updatedFilters;
        // });
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setReportName(e.target.value);
    };

    return (
        <div style={{display: 'flex', justifyContent: 'flex-end', marginTop:'1%'}}>
            {
                getFilters().length?<div style={{
                display:'block',
                border: 'solid lightgray .5px',
                marginRight: '1%',
                padding: '0.3%',
                    width:'100%'
            }}>
                        {getFilters().map((filter, index) => (
                            <Tag key={index}>
                                {filter.field} {filter.operator === 'eq' ? ':' : filter.operator} <span style={{ color: '#2f5e92' }}>{filter.value}</span>
                                <span
                                    style={{ cursor: 'pointer', marginLeft: '5px', color:'red' }}
                                    onClick={() => removeFilter(filter.field)}
                                >
                    x
                </span>
                            </Tag>
                        ) )}

            </div>:null}
            <Tooltip title="Download CSV">
                <Button
                    icon={<DownloadOutlined style={{ fontSize: '20px' }}/>}
                    onClick={downloadCsv}
                    style={{marginRight: '0.5%', textAlign: 'right', fontSize: '20px', height: '25px', width: '25px'}}
                />
            </Tooltip>
            <Tooltip title="Save">
                <Button
                    icon={<SaveOutlined style={{ fontSize: '20px' }}/>}
                    onClick={showModal}
                    style={{marginRight: '1%', textAlign: 'right', fontSize: '20px', height: '25px', width: '25px'}}
                />
            </Tooltip>
            <Modal title="Save Report" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
            <Spin spinning={loading}>
                <Input placeholder="Report name" value={reportName} onChange={handleInputChange} />
            </Spin>
            </Modal>
        </div>
    );
};

export default ButtonGroup;